:host {
  display: block;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  padding: 0;
  border: 0;
  position: relative;
  overflow: hidden;
}

.animated-hero__video {
  display: block;
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: 0;
  transform: translateX(-50%);

  &.no-autoplay {
    display: none;
  }
}

.animated-hero__content {
  position: relative;
  z-index: 5;
}

.shade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
